var document = require('../internals/global').document;

module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/internals/html.js
// module id = 257
// module chunks = 1